import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const DoctorCard = ({ doctor, index }) => {
  const { getDoctor, t } = useLanguage();
  const localizedDoctor = getDoctor(doctor);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow group"
    >
      <div className="aspect-square overflow-hidden bg-gray-100">
        <img 
          src={localizedDoctor.image} 
          alt={localizedDoctor.name} 
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-6 md:p-8">
        <h3 className="text-2xl font-bold text-navy mb-1">{localizedDoctor.name}</h3>
        <p className="text-clinical font-semibold text-sm mb-2">{localizedDoctor.qualification}</p>
        <p className="text-teal font-medium text-sm mb-4">{localizedDoctor.specialization}</p>
        <p className="text-gray-600 mb-6 text-sm leading-relaxed">
          {localizedDoctor.profile}
        </p>
        <Link 
          to={`/appointment?doctor=${encodeURIComponent(doctor.name)}`}
          state={{ doctor: doctor.name }}
          className="inline-flex items-center space-x-2 text-white bg-navy hover:bg-clinical px-6 py-3 rounded-full font-medium transition-colors w-full justify-center"
        >
          <Calendar size={18} />
          <span>{t('doctorsSection.bookConsultation')}</span>
        </Link>
      </div>
    </motion.div>
  );
};

export default DoctorCard;
